import { useRef } from "react";
import {
    Dialog,
    DialogBackground,
    DialogHeader,
    DialogBody,
    DialogTitle,
    DialogText,
    DialogButtonWrapper,
    DialogCancelButton,
} from "../../styles/components/PromisifiedDialogStyles";
import ButtonStyles from "../../styles/components/ButtonStyles";
import { IPromisifiedDialogProps, IPromiseProps } from "./IPromisifiedDialog";

const { BtnPrimary } = ButtonStyles;

const PromisifiedDialog: React.FC<
    IPromisifiedDialogProps & IPromiseProps<boolean>
> = ({
    title,
    text,
    width,
    height,
    acceptButtonText,
    acceptButtonDisabled = false,
    cancelButtonText,
    hasToRenderCancelButton = true,
    onResolve,
    onReject,
    children,
}) => {
    const backRef = useRef(null);

    return (
        <DialogBackground ref={backRef}>
            <Dialog width={width} height={height}>
                <DialogHeader>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => {
                            onReject(false);
                        }}
                    />
                </DialogHeader>
                <DialogBody>
                    <DialogTitle>{title || "Atenção"}</DialogTitle>
                    <DialogText>
                        {text || "Deseja realmente fazer isso?"}
                    </DialogText>
                    {children}
                    <DialogButtonWrapper>
                        <BtnPrimary
                            type="button"
                            onClick={() => {
                                onResolve(true);
                            }}
                            disabled={acceptButtonDisabled}
                        >
                            {acceptButtonText || "Confirmar"}
                        </BtnPrimary>
                    </DialogButtonWrapper>
                    {hasToRenderCancelButton && (
                        <DialogButtonWrapper>
                            <DialogCancelButton
                                type="button"
                                onClick={() => {
                                    onReject(false);
                                }}
                            >
                                {cancelButtonText || "Cancelar"}
                            </DialogCancelButton>
                        </DialogButtonWrapper>
                    )}
                </DialogBody>
            </Dialog>
        </DialogBackground>
    );
};

export { PromisifiedDialog };
export type { IPromiseProps, IPromisifiedDialogProps };
